// extracted by mini-css-extract-plugin
export default {"mainContainer":"Batches_mainContainer__AbpDg","projects":"Batches_projects__-eW1-","dash":"Batches_dash__eVZ9g","addBatch":"Batches_addBatch__cDJXe"};